export { SegmentedControl, type SegmentedControlOption, type SegmentedControlProps } from "./SegmentedControl";
